<template>
  <div class="my-list">
    <div class="post-list" v-if="dataList&&dataList.length">
      <div class="post-info" v-for="item in dataList" :key="item.id" @click="routerHandle(item)">
        <div class="post-info-img">
          <img :src="item.scoreDataAuthorUrl||'/static/img/favicon.ico'" width="74px" height="74px" :alt="item.scoreDataAuthor"/>
        </div>
        <div class="post-detail">
          <div class="post-detail-title overell">{{item.scoreDataTitle}}</div>
          <div class="post-detail-content">{{item.scoreDataContext}}</div>
          <div class="post-detail-time">
            <span>{{item.scoreDataAuthor}} &nbsp;上传&nbsp;|&nbsp;</span>
            <span>{{item.commentCount||0}} &nbsp;回复&nbsp;|&nbsp;</span>
            <span>提问时间：{{item.createTime}}</span>
          </div>
          <div class="rete">
            <el-rate class="rate-choose" disabled v-model="item.scoreValue"></el-rate>
          </div>
          <div class="post-rate-time">
            <span>评价时间：{{item.createTime}}</span>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <div style="text-align:center">
        <img :src="BASE_URL + 'img/kong.png'" alt="暂无数据">
      </div>
    </div>
    <div class="doclist-pagination" v-if="dataList&&dataList.length">
      <div class="doclist-lastpage" @click="jumpLastPage">上一页</div>
      <div class="doclist-omit">{{lastOmit}}</div>
      <ul>
        <li :class="item === currentPage?'pageactive':''" v-for="item in pageList" :key="item" @click="changePageTo(item)">{{item}}</li>
      </ul>
      <div class="doclist-omit">{{nextOmit}}</div>
      <div class="doclist-nextpage" @click="jumpNextPage">下一页</div>
      <div class="doclist-pagejump">共{{totalPage}}页，到第<input type="text" v-model.number="jumpTargetPage">页</div>
      <div class="doclist-jump" @click="jumpFarPage">确定</div>
    </div>
  </div>
</template>

<script>
import { track } from '@/utils/knowledgeEventTracking'
export default {
  data () {
    return {
      BASE_URL: process.env.BASE_URL,
      status: '',
      dataList: [],
      // 分页
      currentPage: 1, // 当前页
      totalPage: 4, // 总页数
      lastOmit: '',
      nextOmit: '...',
      pageList: [1, 2, 3, 4, 5],
      jumpTargetPage: 1 // 跳转页
    }
  },
  computed: {
    // 计算属性的 getter
  },
  mounted () {
    this.getDataList(this.currentPage)
  },
  methods: {
    // 上一页
    jumpLastPage () {
      if (this.currentPage > 1) {
        var newCurrent = this.currentPage - 1
        this.changePageTo(newCurrent)
      } else {
        this.$message.info('这已经是第一页啦')
      }
    },
    //  下一页
    jumpNextPage () {
      if (this.currentPage < this.totalPage) {
        var newCurrent = this.currentPage + 1
        this.changePageTo(newCurrent)
      } else {
        this.$message.info('这已经是最后一页啦')
      }
    },
    //   第几页
    changePageTo (page) {
      this.getDataList(page)
    },
    //   确定跳转到哪页
    jumpFarPage () {
      if (this.jumpTargetPage >= 1 && this.jumpTargetPage <= this.totalPage) {
        this.changePageTo(this.jumpTargetPage)
      } else {
        this.$message.error('请输入正确的页码')
      }
    },
    getDataList (currentPage = this.currentPage) {
      this.$http.post(`${window.SITE_CONFIG['apiURL']}/front/kc/userInfo/userscoreinfo/myScore`, {
        'page': currentPage,
        'limit': 10,
        'status': this.status
      })
        .then(({ data }) => {
          if (data && data.code === 0) {
            this.dataList = data.data.data || []
            this.totalPage = Math.ceil(Number(data.data.count) / 10)
          } else {
            this.dataList = []
            this.totalPage = 0
          }
          this.setPageTo(currentPage)
        })
        .catch(() => {
          this.dataList = []
          this.totalPage = 0
          this.setPageTo(currentPage)
        })
    },
    setPageTo (page) {
      if (this.totalPage > 5) {
        if (page > 2 && page < this.totalPage - 1) {
          var newPageList = []
          for (let index = page - 2; index < page + 3; index++) {
            newPageList.push(index)
          }
          this.pageList = newPageList
          this.currentPage = page
          this.lastOmit = '...'
          this.nextOmit = '...'
        } else if (page <= 2) {
          this.pageList = [1, 2, 3, 4, 5]
          this.currentPage = page
          this.lastOmit = ''
          if (page >= this.totalPage - 2) {
            this.nextOmit = ''
          } else {
            this.nextOmit = '...'
          }
        } else {
          var newPageList2 = [this.totalPage - 4, this.totalPage - 3, this.totalPage - 2, this.totalPage - 1, this.totalPage]
          this.pageList = newPageList2
          this.currentPage = page
          this.lastOmit = '...'
          this.nextOmit = ''
        }
      } else {
        var newPageList5 = []
        for (let index = 1; index <= this.totalPage; index++) {
          newPageList5.push(index)
        }
        this.pageList = newPageList5
        this.lastOmit = ''
        this.nextOmit = ''
        this.currentPage = page
      }
    },
    changeStatus (index) {
      this.status = index
      this.getDataList(1)
    },
    routerHandle (item) {
      if (item.scoreType === 'VIDEO') {
        track.clickVideoDetail(item.videoTitle)
        this.$router.push({
          name: 'knowledgevideoDetil',
          query: {
            videoId: item.scoreDataId
          }
        })
      } else if (item.scoreType === 'POST') {
        this.$router.push({
          name: 'postsDetail',
          query: {
            id: item.scoreDataId
          }
        })
      } else if (item.scoreType === 'FILE') {
        track.clickDocDetail(item.fileTitle)
        this.$router.push({
          name: 'bookDocDetail',
          query: {
            fileId: item.scoreDataId
          }
        })
      }
    }
  }
}
</script>
<style scoped>
.my-list{
  margin: 0 79px;
}
.post-info{
  margin-top: 30px;
  width: 100%;
  display: flex;
  cursor: pointer;
  /* padding-bottom: 28px; */
  border-bottom: 1px solid #eee;
}
.post-info-img{
  width: 68px;
  height: 68p;
}
.post-info-img img{
  width: 68px;
  height: 68px;
  border-radius: 34px;
  overflow: hidden;
}
.post-detail {
  width: 550px;
  margin-right: 20px;
  margin-left: 30px;
}
.post-detail-title{
  text-align: left;
  line-height: 22px;
  font-size: 16px;
  color: #333333;
  letter-spacing: 0.6px;
  height: 22px;
  margin-bottom: 10px;
}
.post-detail-content{
  width: 450px;
  text-align: left;
  line-height: 20px;
  font-size: 14px;
  color: #666666;
  letter-spacing: 0.6px;
  height: 20px;
  margin-bottom: 10px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.post-detail-time{
  width: 100%;
  line-height: 17px;
  font-size: 12px;
  color: #666666;
  letter-spacing: 0.6px;
  padding-bottom: 14px;
  border-bottom: 1px solid #eee;
}
.rete{
  position: relative;
  left: 134px;
}
.rate-choose{
  height: 25px;
  margin-top: 10px;
  margin-bottom: 10px;
  font-size: 25px !important;
  transform: scale(1.5) !important;
}
.post-rate-time{
  text-align: left;
  font-size: 12px;
  color: #666666;
  line-height: 26px;
  height: 26px;
  margin-bottom: 19px;
}
.post-status{
    width: 105px;
    text-align: center;
}
.post-status-success{
  text-align: center;
  line-height: 20px;
  font-size: 14px;
  color: #1D65A8;
  height: 20px;
}
.post-status-ing{
  text-align: left;
  line-height: 20px;
  font-size: 14px;
  color: #E2980A;
  width: 102px;
}
.post-status-fail{
  text-align: center;
  line-height: 20px;
  font-size: 14px;
  color: #BF1B22;
  height: 20px;
}
</style>
